<template src="../../templates/menu-left.html">

</template>

<script>

import $ from 'jquery';
import entityStore from '@/store/entityStore';
import userAuthStore from '@/store/userAuthStore';

export default {
  props: [
    'loggedIn',
  ],
  data() {
    return {
      entity: entityStore.state,
    };
  },
  methods: {
    menuToggle(event) {
      $('.mobile-menu').slideToggle();
      $(event.target).toggleClass('active');
    },
    logOut() {
      userAuthStore.logOut(false);
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// menuLeft.vue?72f0f781